// ----------------------------------------------------------------------------
// Component: Collection List
// ----------------------------------------------------------------------------
//
// A list of collections
//
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import './_collection-list.scss';
